export enum IconMapMarker {
    PATIENT_ACTIVE = 'patient-active',
    PATIENT_INACTIVE = 'patient-inactive',
    PROVIDER_ACTIVE_ADDRESS = 'provider-active-address',
    PROVIDER_ACTIVE_ZONE = 'provider-active-zone',
    PROVIDER_INACTIVE_ADDRESS = 'provider-inactive-address',
    PROVIDER_INACTIVE_ZONE = 'provider-inactive-zone',
    PROVIDER_INACTIVE_POSSIBLE_ADDRESS = 'provider-inactive-possible-address',
    PROVIDER_INACTIVE_POSSIBLE_ZONE = 'provider-inactive-possible-zone',
    PROVIDER_INACTIVE_CANCELLED_ADDRESS = 'provider-inactive-cancelled-address',
    PROVIDER_INACTIVE_CANCELLED_ZONE = 'provider-inactive-cancelled-zone',
    CLUSTER = 'cluster'
}
